<template>
    <v-navigation-drawer expand-on-hover rail>
        <v-list>
            <v-list-item
                :prepend-avatar="require('../assets/user.png')"
                :title="user_name"
                :subtitle="user_email"
            ></v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list density="comfortable" nav active-color="#dba002">
            <v-list-item
                prepend-icon="mdi-view-dashboard"
                title="Dashboard"
                value="dashboard"
                to="dashboard"
            ></v-list-item>
            <v-list-item
                prepend-icon="mdi-shopping"
                title="Marketplace"
                value="marketplace"
                to="marketplace"
            ></v-list-item>
            <v-list-item
                prepend-icon="mdi-transmission-tower"
                title="Net Metering Scheme"
                value="net-metering-scheme"
                to="net-metering-scheme"
            ></v-list-item>
            <v-list-item
                prepend-icon="mdi-home-group"
                title="Community Battery"
                value="community-battery"
                to="community-battery"
            ></v-list-item>
            <v-list-item
                prepend-icon="mdi-heart-pulse"
                title="System Vitals"
                value="system-vitals"
                to="system-vitals"
            ></v-list-item>
        </v-list>

        <template v-slot:append>
            <v-list density="comfortable" nav active-color="#dba002">
                <v-list-item
                    prepend-icon="mdi-bug"
                    title="Report Bug"
                    value="report-bug"
                    to="report-bug"
                ></v-list-item>
                <v-list-item
                    prepend-icon="mdi-logout"
                    title="Logout"
                    value="logout"
                    @click="handleLogout"
                ></v-list-item>
            </v-list>
        </template>
    </v-navigation-drawer>
</template>

<script>
import store from "@/store";
import { computed } from "vue";
import { getAuth, signOut } from "firebase/auth";
import router from "@/router";

export default {
    name: "SideNav",

    setup() {
        const user_name = computed(() => store.state.user?.name);
        const user_email = computed(() => store.state.user?.email);

        const handleLogout = () => {
            if (store.state.user != null) {
                const auth = getAuth();
                signOut(auth)
                    .then(() => {
                        store.dispatch("setCurrentUser", null);
                        router.push("/login");
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        };

        return {
            user_name,
            user_email,
            handleLogout,
        };
    },
};
</script>
